import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type SettingState, type Theme } from '../types';

const changeThemeCase: CaseReducer<
  SettingState,
  PayloadAction<{ theme: Theme }>
> = (state, action) => {
  state.theme = action.payload.theme;

  return state;
};

export { changeThemeCase };
